import './Feedback.css'
import chatPic from '../../../assets/email.png'
import { useState } from 'react'

const API_URL = process.env.REACT_APP_API_URL;

const Feedback = () => {
    const [open, setOpen] = useState(false)
    const [formData, setFormData] = useState({
        Email: '',
        Subject: '',
        Comments: ''
    })

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const toggleForm = () => {
        setOpen(!open)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        try {
            console.log(formData)
            const response = await fetch(`${API_URL}/addfeedback`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })

            if (response.ok) {
                alert('Thank you for your feedback!')
                setFormData({ Email: '', Subject: '', Comments: '' })
                setOpen(false)
            } else {
                alert('Something went wrong.')
            }
        } catch (error) {
            console.error('Submission error:', error)
            alert('Network error.')
        }
    }
    
    return (
        <div className="feedback-container">
            <div className="feedback-bubble" onClick={toggleForm}>
                <img src={chatPic} alt="feedback" style={{ width: '60%', height: '60%', filter: 'brightness(0) invert(1)' }} />
            </div>

            <div className={`feedback-form ${open ? 'active' : ''}`}>
                <h2 style={{ fontWeight: '400'}}>Questions and Feedback</h2>   
                <p style={{ fontWeight: '350', fontSize: '0.9rem' }}>We're here to listen.</p>
                <form onSubmit={handleSubmit}>
                    <input type="email" name="Email" placeholder="Email" value={formData.Email} onChange={handleChange} required />
                    <input type="text" name="Subject" placeholder="Subject" value={formData.Subject} onChange={handleChange} required />
                    <textarea name="Comments" placeholder="Comments" value={formData.Comments} onChange={handleChange} required />
                    <button type="submit">Submit</button>
                </form>
            </div>
        </div>
    )
}

export default Feedback
